import { Component, Input } from '@angular/core';
import { REQUEST_SERVICE_QUALTRICS_FORM_URL } from 'src/app/pages/agreements/constants/request-service-url.constants';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-request-budget-support-item',
  imports: [ButtonComponent, SharedModule],
  templateUrl: './request-budget-support-item.component.html',
  styleUrls: ['./request-budget-support-item.component.scss'],
})
export class RequestBudgetSupportItemComponent {
  // consumer uuid
  @Input() consumerUuid: string;

  @Input() hasPadding = true;

  // support provider uuid
  @Input() supportProviderUuid: string;

  constructor(private utilityService: UtilityService) {}

  /**
   * Opens the link to the service category help centre article.
   */
  openServiceCategoryLink(): void {
    this.utilityService.openExternalLink('https://mable.com.au/help_centre/NDIS-support-items/');
  }

  /**
   * Opens Qualtrics form.
   * This form is needed when SP wants to request a non-standard budget support item to be added to a rate.
   */
  openQualtricsForm(): void {
    const qualtrixFormUrl = `${REQUEST_SERVICE_QUALTRICS_FORM_URL}=${this.supportProviderUuid}&c=${this.consumerUuid}`;
    this.utilityService.openExternalLink(qualtrixFormUrl);
  }
}
